<div class="container flex flex-col gap-2.5">
  <div class="flex flex-row items-center justify-start gap-2.5">
    <ion-icon src="../../../../assets/icon/info.svg"></ion-icon>
    <h1>¡Atención!</h1>
  </div>

  <div>
    <p>
      Por defecto seleccionamos el envío estándar ya que es el más popular. Pero no te preocupes, lo podrás cambiar
      luego por otro tipo de envío si lo deseas.
    </p>
  </div>
</div>
